<template>
    <div class="guest-layout">
        <div class="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Guest',
    mounted() {
    }
  }
</script>

<style lang="scss">
.white-content {
  background: #f5f6fa!important;
  background-image: url(/images/login-background.png)!important;
  background-repeat: no-repeat!important;
  background-attachment: fixed!important;
  background-position: center!important;
  background-size: cover!important;
}
</style>
